import React from 'react';
import Styled from 'styled';
import SVGIcon from 'lib/images/svg-icon/svg-icon';
import defaultStyles from './arrow.scss';
import arrow from 'four-nets/icons/svg/icon_arrow-breadcrumbs.svg';

export interface Props extends React.HTMLAttributes<HTMLButtonElement> {
    styles: typeof defaultStyles;
}

class Arrow extends React.PureComponent<Props> {
    render() {
        const { styles, ...rest } = this.props;
        return (
            <button {...rest} className={styles!.arrow}>
                <SVGIcon style={{ image: styles.icon }} src={arrow} />
            </button>
        );
    }
}

export default Styled(defaultStyles)(Arrow);
